import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InvoiceListComponent } from "./invoice-list/invoice-list.component";
import { authGuard } from "../../shared/guards/auth.guard";
import { InvoiceItemsListComponent } from "./invoice-items-list/invoice-items-list.component";
import { InvoiceLayoutComponent } from "./invoice-layout/invoice-layout.component";
import { InvoiceGeneratorComponent } from "./invoice-generator/invoice-generator.component";

const routes: Routes = [  
  { 
    path: '', 
    component: InvoiceLayoutComponent, 
    canActivate: [authGuard],
    children: [
      { path: '', component: InvoiceListComponent, canActivate: [authGuard] },
      { path: ':invoiceId/items', component: InvoiceItemsListComponent, canActivate: [authGuard] },
      { path: 'generator', component: InvoiceGeneratorComponent, canActivate: [authGuard] },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoicesRoutingModule { }